
export const About = () => {
  return (
    <div className="flex flex-col md:flex-row items-center gap-12 max-w-5xl mx-auto">
      <div className="flex-1 space-y-6">
        <h2 className="text-3xl md:text-4xl font-bold font-heading">About Bright Stages</h2>
        <p className="text-lg leading-relaxed text-gray-600">
          At Bright Stages, we empower parents and educators with the tools to understand, track, and support children's developmental journey from birth to age six. Our research-backed stage testing provides structured assessments across motor skills, language, cognitive development, independence, and social-emotional growth, helping parents and caregivers identify strengths and areas for improvement.
        </p>
        <p className="text-lg leading-relaxed text-gray-600">
          Through a collaborative and interactive approach, Bright Stages encourages engagement, progress tracking, and personalized insights, ensuring every child reaches their full potential at their own pace.
        </p>
      </div>
      <div className="w-full md:w-[350px] relative aspect-square rounded-lg overflow-hidden shadow-xl">
        <img 
          src="/lovable-uploads/9d8f35d8-3bff-434b-8543-f340fda39884.png"
          alt="Parent and child working together"
          className="w-full h-full object-cover object-bottom hover:scale-105 transition-transform duration-300"
        />
      </div>
    </div>
  );
};
